/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/universal-importer`, controller.plan, makeLayout, render);
    router(`/dashboard/universal-importer/edit`, controller.editPlan, makeLayout, render);
    router(`/dashboard/universal-importer/subscribe`, controller.newPlan, makeLayout, render);
};